import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import _ from 'lodash';
import { IMatchPaymentsSelector, ITeamsSelector, ICartSelector } from 'app/types/selector';

import bulkMatchPaymentsActions from 'app/ducks/bulkMatchPayments/actions';
import cartActions from 'app/ducks/cart/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as bulkMatchPaymentsSelectors from 'app/ducks/bulkMatchPayments/selectors';
import * as cartSelectors from 'app/ducks/cart/selectors';

import CartBulkMatchPaymentComponent from './CartBulkMatchPaymentComponent';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    bulkMatchPayments: bulkMatchPaymentsSelectors.getBulkMatchPayments(
      state,
    ),
    cart: cartSelectors.getCart(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(bulkMatchPaymentsActions, cartActions);

interface ICartBulkMatchPaymentProps {
  bulkMatchPayments: IMatchPaymentsSelector;
  teams: ITeamsSelector;
  cart: ICartSelector;
  match: any;
  actions: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class CartBulkMatchPayment extends React.Component<ICartBulkMatchPaymentProps, {}> {
  static defaultProps: ICartBulkMatchPaymentProps = {
    bulkMatchPayments: {},
    teams: {},
    cart: {},
    match: undefined,
    actions: undefined,
  };

  componentDidMount = () => {
    this.props.actions.resetCart({ defaultLoaded: false });
  };

  componentDidUpdate = () => {
    const { currentBulkMatchPayment } = this.props.bulkMatchPayments;
    if (!this.props.cart.defaultLoaded && currentBulkMatchPayment?.id !== undefined && currentBulkMatchPayment.matchPayments.length > 0 && !_.isEmpty(currentBulkMatchPayment.matchPayments[0]?.matchHomeTeamName)) {
      this.compileLineItems(currentBulkMatchPayment);
    }
  }

  compileLineItems = (currentBulkMatchPayment) => {
    const lineItems: any = _.map(currentBulkMatchPayment.matchPayments, (matchPayment) => ({
      amount: matchPayment.amount,
      description: `${matchPayment.groupName} - ${matchPayment.matchRoundName} - ${moment(matchPayment.matchAt).format('D MMM YYYY')}`,
      quantity: 1,
      code: 'match_payment',
    }));
    this.props.actions.updateCart({ defaultLoaded: true, lineItems });
    return lineItems;
  };

  render(): React.ReactNode {
    const { currentBulkMatchPayment } = this.props.bulkMatchPayments;
    if (!_.isEmpty(currentBulkMatchPayment)) {
      return (
        <CartBulkMatchPaymentComponent
          bulkMatchPaymentId={this.props.match.params.bulkMatchPaymentId}
          totalAmount={this.props.cart.totalAmount}
          lineItems={this.props.cart.lineItems}
        />
      );
    }
    return null;
  }
}
